import Vue from 'vue'

let listeners = []

Vue.directive('hide-on-click', {
  bind (el, binding, vnode) {
  },
  unbind () {
    document.body.removeEventListener('click', event)
  },
  update (el, binding, vnode) {
    let selfCloseOnClik

    // definition de l'event à lever
    let closeOnClick = function (event) {
      let refreshListener = []
      listeners.forEach((listener, index) => {
        let fire = false
        if (listener.modifiers.anywhere) {
          fire = true
        }

        if (listener.modifiers.outside) {
          if (!(listener.el === event.target || listener.el.contains(event.target))) {
            fire = true
          }
        }

        if (listener.modifiers.inner) {
          if ((listener.el === event.target || listener.el.contains(event.target))) {
            fire = true
          }
        }
        if (fire) {
          listener.vnode.context[listener.expression] = false
        } else {
          refreshListener.push(listener)
        }
      })
      listeners = refreshListener
      if (listeners === undefined || !listeners.length) document.body.removeEventListener('click', selfCloseOnClik)
    }
    // bind new
    if (binding.value && !binding.oldValue) { // si la valeur de lexpression est differente du precendent update
      // On attache l'event au click selon le modifier
      if (!listeners.length) document.body.addEventListener('click', selfCloseOnClik = closeOnClick)
      listeners.push({
        el,
        modifiers: binding.modifiers,
        expression: binding.expression,
        vnode: vnode
      })
    }
  }
})

// Enregistrer une directive globale appelée `v-focus`
Vue.directive('focus', {
  // Quand l'élément lié est inséré dans le DOM...
  inserted: function (el) {
    // L'élément prend le focus
    if (el.nodeName === 'INPUT') {
      el.focus()
    } else {
      // on recherche le premier input enfant
      el.querySelector('input').focus()
    }
  }
})
